import React from "react";

const TemarioDiplomaturaCuidadosPediatricosRespiratorios = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Bases del sistema respiratorio pediátrico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos"}</span></li>
                <li><span className="fw-light">{"Reconocer los signos y síntomas de alarma de las situaciones que afecten la función respiratoria del niño, evaluando prioridades"}</span></li>
                <li><span className="fw-light">{"Educar al niño y su familia en la prevención de enfermedades respiratorias"}</span></li>
                <li><span className="fw-light">{"Contenido"}</span></li>
                <li><span className="fw-light">{"Características del sistema respiratorio del niño y lactante"}</span></li>
                <li><span className="fw-light">{"Valoración del sistema respiratorio del niño y lactante"}</span></li>
                <li><span className="fw-light">{"Educación y prevención de las patologías respiratorias"}</span></li>
            </ul>
            <br /><br />
            <b>{"Dificultad respiratoria y patologías frecuentes"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos"}</span></li>
                <li><span className="fw-light">{"Reconocer los distintos grados de dificultad respiratoria en el niño, y los criterios de actuación para dicha situación clínica"}</span></li>
                <li><span className="fw-light">{"Contenido"}</span></li>
                <li><span className="fw-light">{"Insuficiencia respiratoria: mecanismo"}</span></li>
                <li><span className="fw-light">{"Criterios de gravedad, escalas de valoración"}</span></li>
                <li><span className="fw-light">{"Patologías respiratorias más frecuentes en pediatría"}</span></li>
                <li><span className="fw-light">{"Bronquiolitis"}</span></li>
                <li><span className="fw-light">{"Bronquitis"}</span></li>
                <li><span className="fw-light">{"Neumonía"}</span></li>
                <li><span className="fw-light">{"Asma"}</span></li>
            </ul>
            <br /><br />
            <b>{"Abordaje de enfermería y soporte respiratorio"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Objetivos específicos"}</span></li>
                <li><span className="fw-light">{"Reconocer los dispositivos adecuados a cada situación de dificultad respiratoria en el niño"}</span></li>
                <li><span className="fw-light">{"Establecer prioridades de actuación para prevenir la claudicación respiratoria"}</span></li>
                <li><span className="fw-light">{"Contenido"}</span></li>
                <li><span className="fw-light">{"Proceso de atención de enfermería al niño con alteraciones de la función respiratoria"}</span></li>
                <li><span className="fw-light">{"Manejo inicial de la dificultad respiratoria"}</span></li>
                <li><span className="fw-light">{"Oxigenoterapia y medicación inhalada"}</span></li>
                <li><span className="fw-light">{"Guías para el manejo de la dificultad respiratoria"}</span></li>
                <li><span className="fw-light">{"Dispositivos para evitar la claudicación"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaCuidadosPediatricosRespiratorios;
